import BaseWidget from "@drift/oneplatfront-components/base-widget";
import { BaseWidgetProps } from "@drift/oneplatfront-components/base-widget/BaseWidgetProps";
import GridItemSize from "@drift/oneplatfront-components/base-widget/GridItemSize";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@vapor/react-extended/ExtendedTypography";
import Box from "@vapor/react-material/Box";
import Stack from "@vapor/react-material/Stack";

import useGetUserInfo from "./hooks/useGetUserInfo";
import WelcomeHumanImg from "./welcome-human-img";

const WelcomeWidget = () => {
    const userInformation = useGetUserInfo();

    const myWidgetProps: BaseWidgetProps = {
        id: "generic_welcome_widget",
        size: GridItemSize.LONG,
        header: {
            title: `Ti diamo il benvenuto ${userInformation?.firstName} ${userInformation?.lastName}`,
        },
        contentSection: {
            content: (
                <Box height="100%">
                    <div>
                        <Typography variant="bodyLarge">
                            Scopri le funzionalit&agrave; di questo nuovo portale.
                        </Typography>
                    </div>
                    <Box sx={{ marginTop: 3 }}>
                        <Typography
                            variant="bodySmall"
                            color="primary.textDisabledColor"
                        >
                            Email personale
                        </Typography>
                        <Stack
                            direction="row"
                            gap={1}
                        >
                            <Typography
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    alignContent: "center",
                                    fontSize: "16px",
                                }}
                            >
                                <FontAwesomeIcon icon={faEnvelope} />
                            </Typography>
                            <Typography variant="body">{userInformation?.email}</Typography>
                        </Stack>
                    </Box>
                </Box>
            ),
        },
        rightSection: {
            content: (
                <Stack
                    direction="row"
                    justifyContent="flex-end"
                >
                    <WelcomeHumanImg
                        height="100%"
                        alt="human_welcome"
                        style={{ maxHeight: "200px" }}
                    />
                </Stack>
            ),
        },
    };

    return <BaseWidget {...myWidgetProps} />;
};

export default WelcomeWidget;
